import { render, staticRenderFns } from "./BannerNew.vue?vue&type=template&id=ce5be432&scoped=true&"
import script from "./BannerNew.vue?vue&type=script&lang=js&"
export * from "./BannerNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5be432",
  null
  
)

export default component.exports